import { render, staticRenderFns } from "./zsDetail.vue?vue&type=template&id=7c09e8b7"
import script from "./zsDetail.vue?vue&type=script&lang=js"
export * from "./zsDetail.vue?vue&type=script&lang=js"
import style0 from "./zsDetail.vue?vue&type=style&index=0&id=7c09e8b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports